module.exports = __webpack_public_path__ + "img/Lanterne_flottante.d288a76.jpg";